import React from "react";
import {CreateLinguisticValue} from "./CreateLinguisticValue";

export class EditLinguisticValue extends CreateLinguisticValue {
    protected needMount: boolean = true;

    componentDidMount() {
        let [namespace, key] = this.getParams();

        this.request.fetch('/linguistic-values/get', {key: key, namespace: namespace})
            .then((values: any) => {

                this.setState({values: values, key: key, namespace: namespace});

            }).catch(error => {
            this.onError(error);
        });
    }

    protected onSuccess(data: any, event: React.FormEvent | null): any {

        const alert = document.querySelector('form .alert.alert-success') as HTMLElement;

        alert.classList.remove('hide');

        setTimeout(function () {
            alert.classList.add('hide');
        }, 5000);
    }
}